//#region Styles
import {
    Column, 
    Part, 
    TitleSection, 
    Fields 
} from "components/styles";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//#endregion
//#region Components
import OnlyDayFields from "views/components/Duration/OnlyDayFields/OnlyDayFields";
//#endregion

const Part2 = ({ 
    form, changeField, 
    changeErrorText, 
    errors, errorTexts
}) => {
    const location = useLocation();
    const isEdit = location.pathname.includes("/editar");
    const { hasWaitlist, duration } = form;
    const [isRefuerzo, setIsRefuerzo] = useState(false);
    const [hasWaitlistLocal, setWaitlist] = useState(hasWaitlist);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        setIsRefuerzo(true);
        if(isEdit && duration.waitlist>0 ){
            setIsDisabled(true);
        }
    }, []);
    useEffect(() => {
		changeField("hasWaitlist", hasWaitlistLocal, false)
	}, [hasWaitlistLocal]);

    //#region Functions
    const changeDuration = (value, errorsValue) => {
        changeField("duration", value, errorsValue);
    };

    const toggleHasWaitlist = value => {
		//value = !!form.duration.manyDays.date.waitlist && !isCreate
		setWaitlist(value)
		//changeField("hasWaitlist", value, false);
	};
    //#endregion
    return (
        <Part paddingBottom="80px">
            <Fields>
                <Column>
                    <Column>
                        <TitleSection>Duraciónn</TitleSection>
                    </Column>
                    <OnlyDayFields
                        duration={form.duration}
                        changeDuration={changeDuration}
                        changeErrorText={changeErrorText}
                        disableControls={isDisabled}
                        isEdit = {isEdit}
                        errors={errors.duration}
                        errorTexts={errorTexts}
                        toggleHasWaitlist={toggleHasWaitlist}
                        hasWaitlist={hasWaitlistLocal}
                        isRefuerzo={isRefuerzo}
                    />
                </Column>
            </Fields>
        </Part>
    );
}

export default Part2;